import { useLocation } from 'tradera/hooks/use-location';
import { URL_LANGUAGES } from 'tradera/lang/constants.mjs';
import { selectEnvironment } from 'tradera/state/environment/selectors';
import { useAppSelector } from 'tradera/state/hooks';

// Add any new NextWeb routes to this array to enable SPA navigation.
// This is the art of the path after the language prefix until the end.
export const NEXTWEB_SPA_REGEX_PATHS = [
    '/item/[0-9]+/([0-9]+)/',
    '/cause/',
    '/charity/',
    '/campaign/',
    '/shop/',
    '/top-lists/',
    '/brand/',
    '/category/([0-9]+)',
    '/profile/information/',
    '/profile/items/',
    '/profile/feedback/',
    '/causes$',
    '/causes/items$',
    '/brands$',
    '/categories$',
    '/how-to-buy$',
    '/how-to-sell$',
    '/my/overview-seller$',
    '/my/wish-list$',
    '/top-lists$',
    '/my/picklist$',
    '/search/detailed$'
];

const PATH_PREFIX = `(/(${URL_LANGUAGES.join('|')}))?`;

const createPathRegex = (pathRegex: string) =>
    new RegExp(`^${PATH_PREFIX}${pathRegex}`);

const NEXTWEB_REGEX_FULL_PATHS = NEXTWEB_SPA_REGEX_PATHS.map(createPathRegex);

export const isNextWebLink = (absoluteUrl: URL, location: URL) => {
    const pathname = absoluteUrl?.pathname;
    const pathnameAndSearch = `${absoluteUrl.pathname}${absoluteUrl.search}`;

    if (absoluteUrl.searchParams.get('next') === '1') {
        return true;
    }

    if (createPathRegex('/?$').test(pathname)) {
        // Prevent SPA navigation to the start page as redux state is reset
        return pathname !== location.pathname;
    }

    if (createPathRegex('/search\\?q=.*').test(pathnameAndSearch)) {
        return true;
    }

    if (NEXTWEB_REGEX_FULL_PATHS.some((regex) => regex.test(pathname))) {
        return true;
    }

    return false;
};

export const useNextWebSpaLink = (absoluteUrl: URL) => {
    const location = useLocation();
    const { isNativeAppContext } = useAppSelector(selectEnvironment);

    if (isNativeAppContext) return false;

    return isNextWebLink(absoluteUrl, location);
};
